import { render, staticRenderFns } from "./IrInvoiceChargesList.vue?vue&type=template&id=78c20fec&"
import script from "./IrInvoiceChargesList.vue?vue&type=script&lang=js&"
export * from "./IrInvoiceChargesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports